// extracted by mini-css-extract-plugin
export default {"btn_notched":"buttonNotched_btn_notched__ISfoy"};